<template>
  <div>
 <br>    

    <div class="col-12">
      <div class="card mb-4">
     

        <div id="LogoVapza">
        
        <b-row>
           
        <b-col md="12">
        <dark-Toggler class="d-soon d-lg-block"  style="text-align: right;"  />
          <b-img
              :src="appLogoImage"
              alt="logo"
              width="100%"
              style="margin: 1%;"
            />
           </b-col>
          </b-row>
        
        
      </div>

      
        <div class="card-header">
          <h4 class="card-title">
            <span>Agendamentos para o Pedido: {{this.pNUNOTA}}</span>
          </h4>
        </div>
      


        <div class="card-body pb-60">

          <div class="DivBotaoLadoLado" v-if="IncluirAgendamento">
              <b-button
                v-b-toggle="'collapse-filtro'"
                variant="primary"
                type="submit"
                @click="incluir()"
              >
              <span>
              <feather-icon
                    icon="PlusCircleIcon"
                    size="15"
              />
              AGENDAR</span>
              </b-button>
              <br><br>
            </div>

          <div>
            <b-table
              :items="listaAgendamentos"
              :fields="listaAgendamentosFields"
              responsive="md"
              striped
              sticky-header
            >

            <template #cell(CONTPEDCOMPLEMENTAR)="row">
                {{ row.value }}
              </template>

            <template #cell(DTENTR)="row">
                {{ row.value ? TextFormat(row.value,'date') : '' }}
              </template>
             

              <template #cell(DHCAD)="row">
                {{ row.value ? TextFormat(row.value,'date') : '' }}
              </template>

              <template #cell(ACOES)="row">
                <b-button
                  v-if="((row.item.STATUSINT == 'DIVERGENTE' 
                    || row.item.NUMNOTA.toString() == '0')
                    && row.item.STATUSINT != 'CONFERIDO' 
                    )"
                  size="sm"
                  variant="outline-primary"
                  @click="editar(row.item)"
                >
                  <feather-icon 
                    icon="EditIcon"
                    size="12"
                  />

                </b-button>


                <b-button
                  size="sm"
                  variant="outline-secondary"
                  @click="editar(row.item)"
                  v-if="(row.item.STATUSINT != 'DIVERGENTE'
                     && row.item.NUMNOTA.toString() != '0') || row.item.STATUSINT == 'CONFERIDO' 
                       "
                >
                  <feather-icon 
                    icon="ZoomInIcon"
                    size="12"
                  />

                </b-button>


              </template>
            
            </b-table>
          </div>
        </div>

        
      </div>
      
    </div>
  </div>
</template>
<script>

import 'bootstrap-icons/font/bootstrap-icons.css'
import {
  BFormGroup,
  BRow,
  BCol,
  BFormDatepicker,
  BButton,
  BTable,
  BFormInput,
  VBToggle, BFormSelect,BImg,
  BadgePlugin
} from 'bootstrap-vue'
import apiPortalSky from '@/services/apiPortalSky'
import AlertaMsg from '@/customPortal/AlertaMsg.vue'
import Spinner from '@/components/Spinner.vue'
import FiltrosPortal from "@/customPortal/FiltrosPortal.vue";
import UtilVUE from '@/customPortal/UtilVUE.vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'

export default {
  components: {
    BFormSelect,
    BFormGroup,
    BFormDatepicker,
    BRow,
    BCol,
    BButton,
    BTable,
    BFormInput,
    BImg,
    DarkToggler,
  },
  directives: { 'b-toggle': VBToggle },
  props: ['nunota', 'edicaoAdm'],
  data() {
    return {
      FiltroTela: {
        TitloTela: 'AgendamentoLista',
        Selecionado: false,
        NUNOTA: '',
        DTENTR: null,
        DTFINAL: null,
        SETOR: null,
        STATUSAGEN: null,
        STATUSINT: null,
        FiltroComplementar: [],
      },
      IncluirAgendamento: true,     
      listaAgendamentos: [],
      listaAgendamentosFields: [
        { 
          key: 'ACOES',
          label: 'EDITAR',
          sortable: true,
          tdClass: 'td100',
        },
        {
          key: 'NUNOTA',
          label: 'N° Pedido',
          sortable: true,
          tdClass: 'td100',
        }.hide,
        {
          key: 'CODAGE',
          label: 'N° Agenda',
          sortable: true,
          tdClass: 'td150',
        },
        {
          key: 'NUMNOTA',
          label: 'N° Nota',
          sortable: true,
          tdClass: 'td150',
        },
       
        {
          key: 'DTENTR',
          label: 'Data de Entrega',
          sortable: true,
          tdClass: 'td100',
        },
        {
          key: 'HORA',
          label: 'Horário',
          sortable: true,
          tdClass: 'td160',
        },
        {
          key: 'RAZAOSOCIAL',
          label: 'Fornecedor',
          sortable: true,
          tdClass: 'td250',
        }.hide,
        {
          key: 'COMPRADOR',
          label: 'Comprador',
          sortable: true,
          tdClass: 'td100',
        }.hide,

        {
          key: 'CONTPEDCOMPLEMENTAR',
          label: 'Qtd Pedidos Complementar',
          sortable: true,
          tdClass: 'td50',
        },
        
        {
          key: 'STATUSINT',
          label: 'Status Interno',
          sortable: true,
          tdClass: 'td100',
        },
        {
          key: 'STATUSAGEN',
          label: 'Status Agendamento',
          sortable: true,
          tdClass: 'td100',
        },
        {
          key: 'DHCAD',
          label: 'Dt. Inclusão',
          sortable: true,
          tdClass: 'td100',
        },
      ],
      pNUNOTA:0,
      appLogoImage:'',
    }
  },
  mounted() {
    this.appLogoImage = require('@/assets/images/logo/LogoVapza.png')

    this.Buscar()
    
    // Trata Notificacao em Session
    if (this.$session.exists('notification')) {
      const notification = this.$session.get('notification')
      this.$session.remove('notification')
      AlertaMsg.FormataMsg(notification)
      
    }
  },
  methods: {

    converterIndiceParaSuperindice(indice){
      if(indice > 0){
       indice = indice+1 //Incluir mais 1 para considerar o proprio agendamento
      return "+"+ UtilVUE.converterIndiceParaSuperindice(indice);
      }else {
        return "";
      }
    },
    
    TextFormat(valor, tipo) {
        return UtilVUE.TextFormat(valor, tipo)
      },
    async Buscar() {

      this.pNUNOTA = 0

      if (this.nunota) {
        this.$session.set('nunotaAgendamento', this.nunota)
        this.pNUNOTA = this.nunota
      }else{
        if (this.$session.exists('nunotaAgendamento')) {
          this.pNUNOTA = this.$session.get('nunotaAgendamento')
       }
      }
      
      if (this.pNUNOTA > 0) {

      Spinner.StarLoad()

      let notification = ''
      this.listaAgendamentos = []

      const usuario = this.$session.get('usuario')
            
      const URL = `/AgendamentoEntrega/Buscar?CODUSU=${usuario.codusu}&NUNOTA=${this.pNUNOTA}&statusagendamento=AGENDADO`
      await apiPortalSky.post(URL).then(response => {

        if (response.status === 200) {
          
          if (response.data.length > 0) {
            this.listaAgendamentos = response.data

            console.log(response.data)

            if(this.listaAgendamentos[0].PENDENTE == "N")
            {
              this.IncluirAgendamento = false
            }


          }
        } else if (response.status === 204) {
          //notification = AlertaMsg.FormataMsgFiltroSemRetorno()
          //AlertaMsg.FormataMsg(notification)
        }
      }).catch(error => {
        notification = AlertaMsg.FormataMsgAPIError(error)
        AlertaMsg.FormataMsg(notification)
      })

      if (notification === '') {
        setTimeout(() => {
          Spinner.EndLoad()
        }, 1000)
      }

      } 
    },
    editar(item) {
      this.$router.push({ name: 'agendamentoEntregaDetalhe',
                          params: { nunota: Number(item.NUNOTA)
                                  , edicaoAdm: false
                                  , edicaoUser: true
                                  , CODAGE: Number(item.CODAGE)
                                  } })
    },
    incluir() {
      this.$router.push({ name: 'agendamentoEntregaDetalhe',
                          params: { nunota: Number(this.pNUNOTA)
                                  , edicaoAdm: false
                                  , edicaoUser: true
                                  , CODAGE: Number(0) 
                                } })
    },
   
    

  },
}
</script>
